export default defineNuxtRouteMiddleware((newRoute) => {
  if (newRoute.fullPath.endsWith('/') && newRoute.fullPath !== '/') {
    return navigateTo(newRoute.fullPath.replace(/\/+$/, ''))
  }
})
